/**
 * Product Block Add to Cart - AJAX handler for single-variant products
 * Based on theme.applyAjaxToProductForm pattern
 */
(function() {
  'use strict';

  // Check if theme and cart drawer are available
  if (typeof theme === 'undefined' || typeof theme.settings === 'undefined') {
    return;
  }

  function initProductBlockATC() {
    // Handle clicks on single-variant Add to Cart buttons
    $(document).on('click', '.product-block-add-to-cart', function(e) {
      e.preventDefault();

      var $btn = $(this);

      // Prevent double-clicks
      if ($btn.data('adding')) {
        return false;
      }

      // Only use AJAX if cart drawer is enabled
      if (theme.settings.cart_type !== 'drawer' || !document.querySelector('cart-drawer')) {
        // Fallback to normal navigation
        window.location.href = $btn.attr('href');
        return false;
      }

      var variantId = $btn.data('variant-id');
      var productTitle = $btn.data('product-title');
      var productId = $btn.data('product-id');

      if (!variantId) {
        console.error('No variant ID found');
        return false;
      }

      // Check if this is a paired item and send analytics
      var isPairedItem = $btn.hasClass('product-block-add-to-cart--pairing');

      if (isPairedItem && window.dataLayer) {
        var $productBlock = $btn.closest('.product-block');
        // Get additional product data
        var price = $productBlock.find('.product-price__amount').first().text().trim();
        var brand = $productBlock.find('.vendor').first().text().trim();
        var priceValue = parseFloat(price.replace(/[^0-9.]/g, '')) || 0;

        // Clear previous ecommerce data (required by GA4)
        window.dataLayer.push({ ecommerce: null });

        // Push custom event for paired item add to cart
        // GTM will transform this to 'add_to_cart' when sending to GA4
        window.dataLayer.push({
          event: 'pairing_add_to_cart',
          item_source: 'paired_items',
          ecommerce: {
            currency: window.Shopify?.currency?.active || 'USD',
            value: priceValue,
            items: [{
              item_id: String(productId || ''),
              item_name: productTitle || '',
              item_variant: String(variantId || ''),
              item_brand: brand || '',
              price: priceValue,
              quantity: 1
            }]
          }
        });
      }

      // Mark as adding and disable
      $btn.data('adding', true);
      var originalText = $btn.text();
      $btn.text(theme.strings.products_product_adding_to_cart || 'Adding...');

      // Prepare form data (same format as theme.applyAjaxToProductForm)
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      // Add sections for cart drawer update
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map(function(section) { return section.id; })
        );
      }
      formData.append('sections_url', window.location.pathname);

      // Set active element for cart drawer
      if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(document.activeElement);
      }

      // AJAX add to cart (same as theme.applyAjaxToProductForm)
      $.post(
        theme.routes.cart_add_url,
        new URLSearchParams(formData).toString(),
        function(response) {
          // Success - update button
          $btn.text(theme.strings.products_product_added_to_cart || 'Added!').addClass('inverted');

          // Use theme's handler to update cart drawer
          if (typeof theme.addedToCartHandler === 'function') {
            theme.addedToCartHandler.call($('<form></form>'), response);
          } else {
            // Fallback: manually update cart drawer
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(response);
              if (cartDrawer.classList.contains('is-empty')) {
                cartDrawer.classList.remove('is-empty');
              }
            }
          }

          // Reset button after 3 seconds
          setTimeout(function() {
            $btn.removeClass('inverted').text(originalText).data('adding', false);
          }, 3000);
        },
        'json'
      ).fail(function(data) {
        // Error handling (same as theme)
        $btn.text(originalText).data('adding', false);

        var errorMessage = 'Sorry, there was an error adding this item to your cart.';

        if (data && data.responseText) {
          try {
            var jsonRes = $.parseJSON(data.responseText);
            errorMessage = jsonRes.description || jsonRes.message || errorMessage;
          } catch(e) {
            // Use default error message
          }
        }

        // Show error popup (same as theme.showQuickPopup)
        if (typeof theme.showQuickPopup === 'function') {
          theme.showQuickPopup(errorMessage, $btn);
        } else {
          alert(errorMessage);
        }
      });

      return false;
    });
  }

  // Initialize on DOM ready
  $(initProductBlockATC);
})();
